import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const ArrowBackComponent = styled.div`
  color: ${colors.strongGray};
  display: flex;
  left: 5%;
  cursor: pointer;
  && {
    font-size: 39px;
  }
`
